// extracted by mini-css-extract-plugin
export var actionText = "_ne-4";
export var container = "_ne-0";
export var leftSection = "_ne-1";
export var rightSection = "_ne-2";
export var settingsButton = "_ne-6";
export var settingsIcon = "_ne-7";
export var shortcut = "_ne-5";
export var shortcutGroup = "_ne-3";